import { render, staticRenderFns } from "./TenancyRecords.vue?vue&type=template&id=9794494a&scoped=true&"
import script from "./TenancyRecords.vue?vue&type=script&lang=js&"
export * from "./TenancyRecords.vue?vue&type=script&lang=js&"
import style0 from "./TenancyRecords.vue?vue&type=style&index=0&id=9794494a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9794494a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9794494a')) {
      api.createRecord('9794494a', component.options)
    } else {
      api.reload('9794494a', component.options)
    }
    module.hot.accept("./TenancyRecords.vue?vue&type=template&id=9794494a&scoped=true&", function () {
      api.rerender('9794494a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenants/dashboards/TenancyRecords.vue"
export default component.exports